import type { NodeEntry } from 'slate';

import type { RenderInlineOptions } from './inline';
import { renderText } from './text';
import type { RenderModelBookmarkStart } from '../../slate-api';
import type { RenderContext } from '../engine/render-context';

export function renderBookmarkStart(
  renderContext: RenderContext,
  rMBookmarkStartEntry: NodeEntry<RenderModelBookmarkStart>,
  options: RenderInlineOptions
) {
  const [rMBookmarkStart] = rMBookmarkStartEntry;
  const { name } = rMBookmarkStart;

  renderContext.drawPDFBookmark(0, 0, { name });

  renderContext.renderChildren(
    rMBookmarkStartEntry,
    { text: renderText },
    {
      ...options,
      inlineVoid: {
        caret: 'start',
        overrideWidthPx: 0,
      },
    }
  );
}
